import { render, staticRenderFns } from "./DialogGroupComponent.vue?vue&type=template&id=503b9ed3&"
import script from "./DialogGroupComponent.vue?vue&type=script&lang=js&"
export * from "./DialogGroupComponent.vue?vue&type=script&lang=js&"
import style0 from "./DialogGroupComponent.vue?vue&type=style&index=0&id=503b9ed3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports